import React, { useEffect } from 'react';
import { batch, useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import cogoToast from 'cogo-toast';

import {
  RESCHEDULE_CLASSES_STAGES,
  resetRescheduleClassesForm,
  resetRescheduleFilters,
  setRescheduleClassesStage,
  useGetSbatGroupListQuery,
} from 'features/classCreation';
import { useGetHolidayListQuery } from 'services/holidayService';
import ErrorLayout from 'components/ErrorLayout';
import GlobalLoader from 'components/GlobalLoader';
import Loader from 'components/Loader';
import RescheduleClassesFilters from './RescheduleClassesFilters';
import RescheduleClassesFilterDrawer from './RescheduleClassesFilterDrawer';
import RescheduleClassesTableStageRenderer from './RescheduleClassesTableStageRenderer';
import SectionHeading from 'components/SectionHeading';

function RescheduleClassesPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { superBatchId } = useParams();
  const { isLoading, isFetching, error, data, refetch } =
    useGetSbatGroupListQuery(Number(superBatchId));
  const { error: holidayError } = useGetHolidayListQuery();

  useEffect(() => {
    if (holidayError) {
      cogoToast.error('Failed to load holidays.');
    }
  }, [holidayError]);

  useEffect(() => {
    return () => {
      batch(() => {
        dispatch(setRescheduleClassesStage(RESCHEDULE_CLASSES_STAGES.view));
        dispatch(resetRescheduleClassesForm());
        dispatch(resetRescheduleFilters());
      });
    };
  }, [dispatch, navigate, superBatchId]);

  if (isLoading) {
    return <Loader />;
  } else if (error) {
    return (
      <ErrorLayout
        title="Failed to load Classes"
        message={error.data?.message || 'Something went wrong! Try again later'}
        actionFn={refetch}
      />
    );
  } else if (data?.data) {
    return (
      <>
        <GlobalLoader isVisible={isFetching} />
        <SectionHeading
          title="RESCHEDULE LECTURES"
          subtitle="Fill in the following details to reschedule lectures"
        />
        <RescheduleClassesFilters />
        <RescheduleClassesFilterDrawer />
        <RescheduleClassesTableStageRenderer />
      </>
    );
  }
}

export default RescheduleClassesPage;
